<template>
    <ul :class="listClasses">
      <li
          v-for="company in props.company_info"
          :key="company.company_id"
          class="chart-item">
          <CompanyItem 
              :company="company" 
              :options="props.options" 
              @deleteCompany="deleteCompany"
              @like="like"
              @unlike="unlike"
          ></CompanyItem>
      </li>
    </ul>
</template>
<script setup lang="ts">
import CompanyItem from "./CompanyItem.vue";
import {computed, ref} from "vue";
import {remove,clone} from 'es-toolkit';

const props = defineProps({
  company_info: {
    type: Object,
    required: true
  },
  options: {
    type: Object,
    required: false
  }
});
const company_info = ref(props.company_info);
const emit = defineEmits(['like','unlike']);


const listClasses = computed(()=>{
  let listClasses = ['chart__list']
  if(props.options.search){
    listClasses.push('is-search')
  }
  return listClasses.join(' ');
})

const deleteCompany = (company) => {
  remove(company_info.value, (c: any) => {
    return c.company_id == company.value.company_id;
  });
}
const like = (company)=>{
  emit('like',company);
}
const unlike = (company)=>{
  emit('unlike',company);
}

</script>